import FlagIcon from 'vue-flag-icon'

export default async ({ Vue }) => {
  Vue.use(FlagIcon)
}
